import rg4js from 'raygun4js';
import { ConfigurationService } from './configuration.service';

class LogService {
  public static init() {
    if (ConfigurationService.get('featureflags.raygun.enabled') === 'True') {
      rg4js('apiKey', 'fqgYRY482IIgyrXEwfozxg');
      rg4js('enableCrashReporting', true);
      rg4js('options', { ignore3rdPartyErrors: true });
    }
  }

  public static logError(error: unknown, logMessage?: string) {
    if (ConfigurationService.get('featureflags.raygun.enabled') === 'True') {
      const errorObject = error instanceof Error ? error : new Error(String(error));
      if (logMessage) {
        rg4js('send', { error: errorObject, customData: { message: logMessage } });
      } else {
        rg4js('send', { error: errorObject });
      }
    }
  }
}

export default LogService;
